import { Component, OnInit } from '@angular/core';
import { DocumentReader, TextFieldFormat } from 'src/app/modules/core/store/models';

@Component({
    selector: 'app-auto-increment-cell',
    templateUrl: './auto-increment-cell.component.html',
    styleUrls: ['./auto-increment-cell.component.scss'],
    standalone: false
})
export class AutoIncrementCellComponent implements OnInit {
  TextFieldFormat = TextFieldFormat;
  value: any;
  format: string;

  constructor() {}

  ngOnInit(): void {}

  agInit(params: any): void {
    const document = params.data;
    const field = params.schemaField;
    const reader = new DocumentReader(document);

    this.format = field?.settings?.format;
    if (!this.format) {
      this.format = TextFieldFormat.SingleLine;
    }

    this.value = !!params.data ? reader.getFieldValue(field.systemName) : params.value;
  }
}
